<template>
  <div class="store">
    <SiruiSearch
      ref="storeDataSearch"
      :query="query"
      :columns="searchFormColumns"
      :defaultRow="2"
      multiple
      @resetBtnClick="resetBtnClickHandler"
      @searchBtnClick="queryBtnClickHandler"
    ></SiruiSearch>
    <div class="main-content">
      <SiruiTable
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          type="seq"
          width="80"
          title="序号"
          v-if="columnList.length"
        ></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <template v-if="item.field === 'businessCategory'">{{
              dictListMap?.businessCategory?.find((item) => item.value == row['businessCategory'])
                ?.label
            }}</template>
            <template v-else-if="item.field === 'expenseType'">{{ '监管费' }}</template>
            <template v-else-if="item.field === 'processStatus'">{{
              row['processStatus'] == 0 ? '未处理' : '已处理'
            }}</template>
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </SiruiTable>
    </div>
    <AddAndEditCostDialog
      ref="AddAndEditCostDialogRef"
      @refreshTable="getTableData"
    ></AddAndEditCostDialog>
  </div>
</template>

<script>
  import superviseContractAPI from '@/api/receivablesAndPayables/superviseContract.js';
  import { searchColumns, defaultTableColumn, defaultMenuBtnList } from './index.js';
  import statementListMixin from './index.js';
  import BASE_API from '@/api/dataBase';
  import AddAndEditCostDialog from './SuperviseContractDetail/components/AddAndEditCostDialog/index.vue';
  export default {
    name: 'SupervisionSheet',
    mixins: [statementListMixin],
    data() {
      return {
        load: false,
        // searchColumns, // 搜索表单
        forbidden: true, // 是否禁用
        sellForbid: true,
        purchaseForbid: true,
        sellSubjectRule: [], // 销售数据对账科目校验规则
        purchaseSubjectRule: [], // 采购数据对账科目校验规则
        subjectList: [], // 对账科目销售
        subjectProcureList: [], //采购
        idList: [],
        reason: null,
        handleRejectValue: '',
        menuButtonList: [], // 表格功能按钮
        multipleSelection: [], // 表格被选中的行数据
        tableData: [{ id: 1 }], // 表格数据
        partnerTypeData: {}, // 合作伙伴类型 => 用于表格回显
        requestStatusData: {}, // 状态 => 用于表格回显
        partnerTypeList: [], // 合作伙伴类型下拉
        requestStatusList: [], // 状态下拉
        importUrl: '',
        importData: {},
        columnList: [],
        companyList: [],
        departmentList: [], //部门列表
        expenseTypeList: [], //费用类型
      };
    },
    computed: {
      searchFormColumns() {
        return searchColumns(this);
      },
    },
    mounted() {
      this.getTableData();
      this.getButtonList();
      this.$nextTick(() => {
        // this._getCompanyApi();
      });
      this.expenseTypeList = this.dictListMap?.expenseType;
    },
    methods: {
      //获取菜单按钮
      getButtonList() {
        this.menuButtonList = defaultMenuBtnList;
        this.getColumnInfo();
        // this.getButtons().then((e) => {
        //   // TODO 后端还没处理好返回数据，前端先这样处理
        //   this.menuButtonList = e.length > 0 ? e : defaultMenuBtnList;
        //   this.getColumnInfo();
        // });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(defaultTableColumn).then(() => {
          // console.log(11111);
          this.columnList = defaultTableColumn;
        });
      },
      // 获取表格数据
      getTableData() {
        this.tableData = [];
        // console.log(search, '搜索');
        const params = {
          ...this.query,
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
          businessGroup: this.userInfo.businessGroup,
        };
        this.$axios.post(`${superviseContractAPI.GET_PAGE_TABLE}`, params).then((res) => {
          console.log('res', res);
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records.map((item, index) => {
              return {
                ...item,
                createMethod: item.createMethod == '01' ? '系统' : '手动',
                rowNo: index + 1,
              };
            });
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          }
        });
      },
      // 表格上面的按钮
      chooseClick(type) {
        console.log(type, '点击按钮操作');
        if (type === 'export') {
          this.exportFileHandler();
        } else if (type === 'create') {
          this.createHandler();
        } else if (type === 'editExpense') {
          this.editExpenseHandler('edit');
        } else if (type === 'addExpense') {
          this.editExpenseHandler('add');
        }
      },
      // 新增、调整费用
      editExpenseHandler(status) {
        if (status == 'edit' && this.multipleSelection.length < 1) {
          this.$message({
            showClose: false,
            type: 'warning',
            message: '您还没有选择数据',
          });
          return;
        }
        if (status == 'edit' && this.multipleSelection.length > 1) {
          this.$message({
            showClose: false,
            type: 'warning',
            message: '请选择一条数据',
          });
          return;
        }
        if (
          status == 'edit' &&
          !this.multipleSelection.map((item) => item.processStatus).every((item) => item == 0)
        ) {
          this.$message({
            showClose: false,
            type: 'warning',
            message: '请选择未处理的单',
          });
          return;
        }
        const data = {
          status: status,
          contractNo: this.multipleSelection[0]?.contractNo,
          expenseNo: this.multipleSelection[0]?.expenseNo,
          customerNo: this.multipleSelection[0]?.customerNo,
        };
        console.log('multipleSelection', this.multipleSelection);
        this.$refs.AddAndEditCostDialogRef.openModal(data);
      },
      createHandler() {
        if (this.multipleSelection.length < 1) {
          this.$message({
            showClose: false,
            type: 'warning',
            message: '您还没有选择数据',
          });
          return;
        }
        if (!this.multipleSelection.map((item) => item.processStatus).every((item) => item == 0)) {
          this.$message({
            showClose: false,
            type: 'warning',
            message: '请选择未处理的单',
          });
          return;
        }
        if ([...new Set(this.multipleSelection.map((item) => item.contractNo))].length > 1) {
          this.$message({
            showClose: false,
            type: 'warning',
            message: '所选合同不一致',
          });
          return;
        }
        if ([...new Set(this.multipleSelection.map((item) => item.customerNo))].length > 1) {
          this.$message({
            showClose: false,
            type: 'warning',
            message: '所选客户不一致',
          });
          return;
        }
        const idList = this.multipleSelection.map((item) => item.id);
        let path = {
          path: '/receivablesAndPayables/superviseContractDetail',
          name: 'superviseContractDetail',
          meta: {
            keepAlive: true,
            title: '监管单应收费用结算清单',
          },
          query: {
            status: 'create',
            id: idList,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 导出
      async exportFileHandler() {
        const ids = this.multipleSelection.map((item) => item.id);
        const { data } = await this.$axios.post(superviseContractAPI.EXPORT_EXCEL, {
          ids,
          ...this.query,
        });
        if (data.code === 0) {
          window.location.href = data.data;
          this.$message.success('导出成功');
        } else {
          this.$message.error('导出失败');
        }
      },
      // 表格选择行
      handleSelectionChange(row) {
        console.log(row);
        this.multipleSelection = row;
      },
      // 搜索
      queryBtnClickHandler() {
        console.log('搜索query', this.query);
        this.$refs.siruiTable.setPageNum(1);
        this.idList = [];
        this.getTableData();
      },
      // 重置
      resetBtnClickHandler() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.idList = [];
        this.query = { businessCategory: '05' };
        this.getTableData();
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
      // 获取公司
      async _getCompanyApi() {
        // console.log('开始获取公司', this.userInfo);
        const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        });
        if (data.code == 0) {
          // console.log(data.data, '???=====》》');
          this.companyList = data.data?.personCompanyInfo;
          // console.log(this.companyList, 'companyList');
          // console.log(this.userInfo.companyCode, 'this.userInfo.companyCode');

          if (!this.userInfo.companyCode) {
            // console.log('非userInfo');
            const companyCode = data.data.personCompanyInfo
              ? data.data.personCompanyInfo[0].companyCode
              : null;
            const companyName = data.data.personCompanyInfo
              ? data.data.personCompanyInfo[0].companyName
              : null;
            this.query = {
              ...this.query,
              businessCompanyNo: companyCode,
              businessCompanyName: companyName,
            };
          } else {
            // console.log('userInfo');
            this.query = {
              ...this.query,
              businessCompanyNo: this.userInfo.companyCode,
              businessCompanyName: this.userInfo.companyName,
            };
          }

          this._getDepartmentByCompanyCodeApi(this.query.businessCompanyNo, true);
        } else {
          console.error('获取公司失败');
        }
      },
      // 根据公司获取部门
      async _getDepartmentByCompanyCodeApi(companyCode, isFirst = false) {
        const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: companyCode,
        });
        if (data.code == 0) {
          // console.log(data.data, '部门信息');
          this.departmentList = data.data?.personDepartmentInfo;
          if (isFirst) {
            this.query = {
              ...this.query,
              businessDepartmentCode: this.userInfo?.departmentCode,
              businessDepartmentName: this.userInfo?.departmentName,
            };
            setTimeout(() => {
              this.getTableData();
            }, 10);
          }
        } else {
          console.error('获取部门失败');
        }
      },
      // 切换公司
      changeCompanyHandler(val) {
        // console.log(val, '切换公司');
        const item = this.companyList.find((item) => item.personCompanyCode == val);
        // console.log(item, '切换公司item');
        this.query = {
          ...this.query,
          businessDepartmentCode: '',
          businessDepartmentName: '',
          businessCompanyNo: val,
          businessCompanyName: item.personCompanyName ? item.personCompanyName : '',
        };
        // 获取部门数据
        this._getDepartmentByCompanyCodeApi(val);
      },
      // 切换部门
      changeDepartmentHandler(val) {
        // console.log(val, '切换部门');
        // console.log(this.departmentList, 'this.departmentList');

        const item = this.departmentList.find((item) => item.personDepartmentCode == val);
        this.query = {
          ...this.query,
          businessDepartmentCode: val,
          businessDepartmentName: item.personDepartmentName ? item.personDepartmentName : '',
        };
      },
    },
    components: { AddAndEditCostDialog },
  };
</script>

<style lang="scss" scoped>
  .pageContent {
    border: 1px solid #e4e7ed;
    border-top: none;
  }
</style>
